import {
  EMPLOYEE_LIST_PAGE_REQUEST,
  EMPLOYEE_LIST_SUBMIT_FORM,
  EMPLOYEE_LIST_SET_EMPLOYEES,
  EMPLOYEE_LIST_RESEND_INVITATION,
  EMPLOYEE_LIST_SHOW_DELETE_EMPLOYEE_MODAL,
  EMPLOYEE_LIST_HIDE_DELETE_EMPLOYEE_MODAL,
  EMPLOYEE_LIST_CANCEL_DELETE_EMPLOYEE,
  EMPLOYEE_LIST_ASK_DELETE_EMPLOYEE,
  EMPLOYEE_LIST_CONFIRM_DELETE_EMPLOYEE,
  EMPLOYEE_LIST_SET_DELETED_EMPLOYEE,
  EMPLOYEE_LIST_SHOW_ASSIGN_OUTLET_MODAL,
  EMPLOYEE_LIST_HIDE_ASSIGN_OUTLET_MODAL,
  EMPLOYEE_LIST_SET_OUTLETS,
  EMPLOYEE_LIST_UNCHECK_ALL_OUTLETS,
  EMPLOYEE_LIST_CHECK_ALL_OUTLETS,
  EMPLOYEE_LIST_SEARCH_OUTLET,
  EMPLOYEE_LIST_SET_CHECKED_OUTLETS,
  EMPLOYEE_LIST_ASSIGN_OUTLETS,
  EMPLOYEE_LIST_CONFIRM_ASSIGN_OUTLETS,
  EMPLOYEE_LIST_CANCEL_ASSIGN_OUTLETS,
  EMPLOYEE_LIST_SET_PROFILE
} from './constants'

export function pageRequest () {
  return {type: EMPLOYEE_LIST_PAGE_REQUEST, payload: {}}
}

export function submitForm (data, params) {
  return {type: EMPLOYEE_LIST_SUBMIT_FORM, payload: {data, params}}
}

export function setEmployees (employees) {
  return {type: EMPLOYEE_LIST_SET_EMPLOYEES, payload: {employees}}
}

export function resendInvitation (email) {
  return {type: EMPLOYEE_LIST_RESEND_INVITATION, payload: {email}}
}

export function setDeletedEmployee (deletedEmployee) {
  return {type: EMPLOYEE_LIST_SET_DELETED_EMPLOYEE, payload: {deletedEmployee}}
}

export function showDeleteEmployeeModal () {
  return {type: EMPLOYEE_LIST_SHOW_DELETE_EMPLOYEE_MODAL, payload: {}}
}

export function hideDeleteEmployeeModal () {
  return {type: EMPLOYEE_LIST_HIDE_DELETE_EMPLOYEE_MODAL, payload: {}}
}

export function askDeleteEmployee (deletedEmployee) {
  return {type: EMPLOYEE_LIST_ASK_DELETE_EMPLOYEE, payload: {deletedEmployee}}
}

export function confirmDeleteEmployee (deletedEmployee) {
  return {type: EMPLOYEE_LIST_CONFIRM_DELETE_EMPLOYEE, payload: {deletedEmployee}}
}

export function cancelDeleteEmployee (deletedEmployee) {
  return {type: EMPLOYEE_LIST_CANCEL_DELETE_EMPLOYEE, payload: {}}
}

export function showAssignOutletModal () {
  return {type: EMPLOYEE_LIST_SHOW_ASSIGN_OUTLET_MODAL, payload: {}}
}

export function hideAssignOutletModal () {
  return {type: EMPLOYEE_LIST_HIDE_ASSIGN_OUTLET_MODAL, payload: {}}
}

export function setOutlets (outlets) {
  return {type: EMPLOYEE_LIST_SET_OUTLETS, payload: {outlets}}
}

/**
 *
 * @param fields
 * @param formName
 * @param fieldName
 * @return {{type, payload: {outlets: *, formName: *, fieldName: *}}}
 */
export function checkAllOutlets (fields, formName, fieldName) {
  return {type: EMPLOYEE_LIST_CHECK_ALL_OUTLETS, payload: {fields, formName, fieldName}}
}

export function uncheckAllOutlets (fields, formName, fieldName) {
  return {type: EMPLOYEE_LIST_UNCHECK_ALL_OUTLETS, payload: {fields, formName, fieldName}}
}

export function searchOutlet (outlets, formName, fieldName, keyword) {
  return {type: EMPLOYEE_LIST_SEARCH_OUTLET, payload: {outlets, formName, fieldName, keyword}}
}

export function setCheckedOutlets (outlets) {
  return {type: EMPLOYEE_LIST_SET_CHECKED_OUTLETS, payload: {outlets}}
}

export function assignOutlets (previousOutlets, inviteForm) {
  return {type: EMPLOYEE_LIST_ASSIGN_OUTLETS, payload: {previousOutlets, inviteForm}}
}

export function confirmAssignOutlets (outlets) {
  return {type: EMPLOYEE_LIST_CONFIRM_ASSIGN_OUTLETS, payload: {outlets}}
}

export function cancelAssignOutlets (previousOutlets, formName, fieldName) {
  return {type: EMPLOYEE_LIST_CANCEL_ASSIGN_OUTLETS, payload: {previousOutlets, formName, fieldName}}
}

export function setProfile (profile) {
  return {type: EMPLOYEE_LIST_SET_PROFILE, payload: {profile}}
}



// WEBPACK FOOTER //
// ./app/actions/employees/list/list.js